import CardTabs, { TabObject } from 'Chakra/CardTabs';
import { localizeAndFormat } from 'Shared/utils/numberFormat';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

// Type definition for view tabs with extended properties
interface ViewTab {
   name: string;
   url: string;
   data?: any;
   id?: string;
}

interface UserTabsProps {
   viewTabs: ViewTab[];
   notifBadge: number;
   currentTab: string;
   setCurrentTab: (name: string) => void;
   tabIcons?: Record<string, IconDefinition>;
}

export function UserTabs({
   viewTabs,
   notifBadge,
   currentTab,
   setCurrentTab,
   tabIcons,
}: UserTabsProps) {
   const viewTabsWithHandlers: TabObject[] = viewTabs.map(tabObject => {
      const baseTab: TabObject = {
         ...tabObject,
         label: tabObject.name,
         id: `${tabObject.name.toLowerCase()}Tab`,
         panel: document.createElement('div'), // Placeholder panel element
         handler: () => {
            setCurrentTab(tabObject.name);
            window.history.replaceState(null, '', tabObject.url + window.location.search);
         },
         ...(tabIcons?.[tabObject.name] ? { icon: tabIcons[tabObject.name] } : {}),
      };

      // Add badge for notifications
      if (tabObject.name === 'Notifications' && notifBadge > 0) {
         baseTab.badge = localizeAndFormat(notifBadge, { notation: 'compact' }) as any;
      }

      return baseTab;
   });
   const activeIndex = viewTabs.findIndex(tab => tab.name === currentTab);

   return (
      <>
         <CardTabs activeTab={activeIndex} tabsData={viewTabsWithHandlers} cardGap="10px" />
      </>
   );
}
